import { makeStyles } from '@mui/styles';

const useGenerateGuideContainerStyles = makeStyles({
	box: {
		background: 'white',
		height: 'auto',
		borderRadius: '20px',
		maxHeight: 'auto',
		margin: 'auto',
		width: '90%',
	},
	root: {
		marginTop: '5%',
	},
	containerTitle: {
		paddingLeft: '5% !important',
		color: '#003C82',
		fontFamily: 'Montserrat',
		fontWeight: 'bold',
		fontSize: 16,
		width: 'auto',
		paddingTop: 1,
	},
	filters: {
		width: '92%',
		marginTop: 0,
		marginRight: 46,
		marginBottom: '15px',
	},
	filtersOpen: {
		width: '84%',
		margin: 'auto',
		marginBottom: '15px',
	},
	tooltip: {
		fontSize: '10px !important',
		fontFamily: 'Montserrat, Medium',
		backgroundColor: '#686868 !important',
		color: 'white !important',
		borderRadius: '10px !important',
		width: 'auto',
		textAlign: 'center',
		padding: '4px 12px !important',
		marginTop: '-5px !important',
	},
	arrow: {
		color: 'white !important',
	},
	paginator: {
		padding: '20px 30px 0px 0px',
		marginTop: 15,
		width: '100%',
	},
});

export default useGenerateGuideContainerStyles;
